import { apiConstants } from "@data/constants/apiConstants"
import { chaptersService } from "@data/services/chaptersService"

const initialState = {
    chaptersList: [],
    // Map of chapter_id -> array of skill_parts ({ id, name, position }).
    // Cached so re-opening the same chapter in the activity-generation modal
    // doesn't re-fetch.
    skillPartsByChapterId: {},
}

export default function chapters(state = initialState, action) {
    switch (action.type) {
        case chaptersService.getChaptersAsStudent.name + apiConstants._SUCCESS:
        case chaptersService.getChaptersForStudents.name +
            apiConstants._SUCCESS:
        case chaptersService.getChaptersAsTutor.name + apiConstants._SUCCESS:
            let chaptersList = []
            if (action.data?.meta?.current_page === 1) {
                chaptersList = action.data?.chapters
            } else {
                chaptersList = state.chaptersList.concat(action.data?.chapters)
            }
            return {
                ...state,
                chaptersList: chaptersList,
            }
        case chaptersService.getChaptersBySchoolSubjectId.name +
            apiConstants._SUCCESS:
            return {
                ...state,
                chaptersList: action.data || [],
            }
        case chaptersService.getChapterSkillParts.name + apiConstants._SUCCESS: {
            const chapterId = action.routeParams?.chapterId
            const skillParts = action.data?.skill_parts || []
            if (!chapterId) {
                return state
            }
            return {
                ...state,
                skillPartsByChapterId: {
                    ...state.skillPartsByChapterId,
                    [chapterId]: skillParts,
                },
            }
        }

        default:
            return state
    }
}
